import Image from "next/image";

const BenefitsOEMs = ({ data }) => {
  const { sectionTitle, subheading, image, industryUse } = data;

  return (
    <section>
      <div className="container mx-auto px-3 flex flex-wrap items-center">

        <div className="w-1/2 sm:w-full pr-6 sm:pr-0 sm:mb-10">
          <h2 className="text-heading text-baseBlack font-medium mb-4 sm:text-xl text-center">
            {sectionTitle}
          </h2>
          <p className="text-lg text-baseBlack mb-10 text-center">
            {subheading}
          </p>
          <Image
            src={image}
            width={520}
            height={270}
            alt="OEM Illustration"
            className="w-full h-auto"
          />
        </div>

        {/* Cards */}
        <div className="w-1/2 sm:w-full flex flex-wrap gap-4">
          {industryUse.map((item) => (
            <div
              key={item.id}
              className="py-6 px-3 rounded-xl border border-borderColor w-[47%] sm:w-full"
              style={{ backgroundColor: item.color }}
            >
              <h3 className="text-baseBlack text-base2 font-medium mb-2">
                {item.heading}
              </h3>

              <p className="text-base text-[#1A1A1A]">
                {item.subHeading}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default BenefitsOEMs;